<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1">
          <feather-icon
            icon="FlagIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Protests</span>
        </h3>
        <!-- <div class="d-flex">
          <b-button class="mt-1 mr-50" @click="removeProtests">
            <feather-icon icon="Trash2Icon" />
            <span> Delete </span>
          </b-button>
        </div> -->
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center p-50">
          <b-form-input
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button class="w-100" type="submit" :disabled="!search">
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>

      <data-table
        :fields="fields"
        :items="protests"
        :loading="loading"
        @onRowClicked="
          selectedItem = $event;
          showModal = true;
        "
      >
        <template #selectprotests="{ data }">
          <div class="d-flex">
            <div class="pr-50 border-right mr-75">
              <!-- <b-form-checkbox
                v-model="removeProtestsData"
                :value="data.item.id"
              ></b-form-checkbox> -->
              <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
            </div>
          </div>
        </template>

        <template #id="{ data }">
          <span class="text-white">{{ data.item.id || "-" }}</span>
        </template>
        <template #subject="{ data }">
          {{ data.item.subject || "-" }}
        </template>
        <template #competition="{ data }">
          {{ data.item.competition_id || "-" }}
        </template>
        <template #email="{ data }">
          {{ data.item.email || "-" }}
        </template>
        <template #content="{ data }">
          <div
            style="white-space: nowrap; max-width: 100px"
            class="text-truncate"
          >
            {{ data.item.content || "-" }}
          </div>
        </template>
        <template #status="{ data }">
          <b-badge
            class="p-75"
            :variant="
              data.item.status == 'PENDING'
                ? 'light-warning'
                : data.item.status == 'REJECTED'
                ? 'light-danger'
                : 'light-success'
            "
          >
            {{ data.item.status.toLowerCase() || "-" }}
          </b-badge>
        </template>
        <template #created_at="{ data }">
          <span class="nowrap-white-space">
            {{ toLocal(data.item.created_at) || "-" }}
          </span>
        </template>
        <template #actions="{ data }">
          <div class="nowrap-white-space">
            <b-dropdown no-caret class="d-flex d-xl-none more-option">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" />
              </template>
              <b-dropdown-item
                variant="flat-primary"
                @click="
                  showChangeStatus = true;
                  currentData = data.item;
                "
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="EditIcon" class="mr-50" />Change status
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <div class="d-xl-flex d-none">
              <b-button
                variant="flat-primary"
                class="mx-25"
                @click="
                  showChangeStatus = true;
                  currentData = data.item;
                "
                ><feather-icon icon="EditIcon" />Change status</b-button
              >
              <!-- <b-button
                class="mx-25"
                variant="flat-danger"
                @click="removeProtest(data.item)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="ml-50">Delete</span>
              </b-button> -->
            </div>
          </div>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-card>
    <protests-change-status-modal
      :showChangeStatus="showChangeStatus"
      v-model="showChangeStatus"
      :currentData="currentData"
      @updateProtests="getProtests"
    />
    <b-modal
      v-model="showModal"
      centered
      hide-footer
      :title="selectedItem.subject"
      title-class="h3"
    >
      <p class="py-1 mb-0">
        {{ selectedItem.content }}
      </p>
    </b-modal>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ProtestsChangeStatusModal from "./protests-change-status-modal/ProtestsChangeStatusModal.vue";
import VSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    ProtestsChangeStatusModal,
    VSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      showModal: false,
      selectedItem: {},
      selectAll: false,
      visibleCreateprotest: false,
      showChangeStatus: false,
      currentData: {},
      removeProtestsData: [],
      url: "/panel/protests",
      pages: [],
      types: [
        { label: "Status", value: "status" },
        { label: "Subject", value: "subject" },
        { label: "Content", value: "content" },
      ],
      type: "",
      search: "",
      selectedPage: "",
      currentPage: 1,
      loading: false,
      pagination: {},
      fields: [
        { key: "selectprotests", label: "row" },
        { key: "id", label: "id" },
        { key: "subject", label: "subject" },
        { key: "competition", label: "competition" },
        { key: "content", label: "content" },
        { key: "status", label: "status" },
        { key: "created_at", label: "created at" },
        { key: "actions", label: "operation" },
      ],
      protests: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/protests") {
        this.$router.push({
          name: "protests",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "protests",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.removeProtestsData = [];
        this.getProtests();
      },
      immediate: true,
      deep: true,
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removeProtestsData = this.protests.map(
              (protest) => protest.id
            ))
          : (this.removeProtestsData = []);
      },
      immediate: true,
    },
    removeProtestsData: {
      handler(val) {
        val.length == this.protests.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "protests",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "protests",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        filter[this.type] = this.search;
        this.$router.push({
          name: "protests",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/protests") {
        this.$router.push({
          name: "protests",
        });
      }
    },
    removeProtest(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/protests/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeProtestsData = [];
                await this.getProtests();
              } else {
                await this.$router.push({
                  name: "protests",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeProtests() {
      if (this.removeProtestsData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removeProtestsData.map(
                  async (faq) =>
                    await this.$http.delete(`/panel/protests/${faq}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeProtestsData = [];
                  await this.getProtests();
                } else {
                  await this.$router.push({
                    name: "protests",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },

    async getProtests() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.protests = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
